var map = {
	"./Eric Frenzel_Stephan Peplies_ Skispitzen_Interview.pdf": 3015,
	"./Sieger Maschen_auszug.pdf": 3857,
	"./auszug aus Buch_Eric_Frenzel.pdf": 761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3625;